import { render } from "./StepFooter.vue?vue&type=template&id=08752b00&scoped=true"
import script from "./StepFooter.vue?vue&type=script&lang=js"
export * from "./StepFooter.vue?vue&type=script&lang=js"

import "./StepFooter.vue?vue&type=style&index=0&id=08752b00&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/doineedavpn.com/doineedavpn.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08752b00"]])

export default __exports__